import create from "zustand";

interface ChartInDialogState {
  isDialogVisible: boolean;
  dateFrom: Date | null;
  dateTo: Date | null;
  header: string | null;
  identifier: string | null;
  identifiers: string[] | null;
  setDialogVisibility: (isVisible: boolean) => void;
  setDateFrom: (date: Date | null) => void;
  setDateTo: (date: Date | null) => void;
  setHeader: (header: string | null) => void;
  setIdentifier: (identifier: string | null) => void;
  setIdentifiers: (identifiers: string[] | null) => void;
}

const useChartInDialogStore = create<ChartInDialogState>((set) => ({
  isDialogVisible: false,
  dateFrom: null,
  dateTo: null,
  header: null,
  identifier: null,
  identifiers: null,
  setDialogVisibility: (isVisible) => set({ isDialogVisible: isVisible }),
  setDateFrom: (date) => set({ dateFrom: date }),
  setDateTo: (date) => set({ dateTo: date }),
  setHeader: (header) => set({ header }),
  setIdentifier: (identifier) => set({ identifier }),
  setIdentifiers: (identifiers) => set({ identifiers }),
}));

export default useChartInDialogStore;
